(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6305],{

/***/ 3658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ Banner; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41796);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57922);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87357);
/* harmony import */ var _mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10224);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);







var useStyles = (0,_mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(theme) {
    var _obj;
    return {
        root: {},
        content: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, theme.typography.body2), (_obj = {
            backgroundColor: theme.colors.softGrey,
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            justifyContent: "center",
            lineHeight: 1.3,
            minHeight: 42,
            padding: theme.spacing(),
            textAlign: "center"
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, theme.breakpoints.up("sm"), {
            padding: theme.spacing(1, 2)
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "& strong", {
            display: "inline-block",
            margin: theme.spacing(0, 0.5),
            padding: theme.spacing(0, 0.5),
            borderRadius: theme.spacing(0.5),
            backgroundColor: theme.colors.warning.main,
            fontWeight: theme.typography.fontWeightBold
        }), _obj)),
        big: {
            fontSize: 16
        },
        small: {},
        success: {
            backgroundColor: (0,_mui_material__WEBPACK_IMPORTED_MODULE_5__/* .lighten */ .$n)(theme.palette.success.light, 0.8),
            color: (0,_mui_material__WEBPACK_IMPORTED_MODULE_5__/* .darken */ ._j)(theme.palette.success.dark, 0.5),
            "& a": {
                color: (0,_mui_material__WEBPACK_IMPORTED_MODULE_5__/* .darken */ ._j)(theme.palette.success.dark, 0.5)
            }
        },
        info: {
            backgroundColor: (0,_mui_material__WEBPACK_IMPORTED_MODULE_5__/* .lighten */ .$n)(theme.palette.info.main, 0.85),
            color: (0,_mui_material__WEBPACK_IMPORTED_MODULE_5__/* .darken */ ._j)(theme.palette.info.main, 0.5),
            "& a": {
                color: (0,_mui_material__WEBPACK_IMPORTED_MODULE_5__/* .darken */ ._j)(theme.palette.info.main, 0.5)
            }
        },
        warning: {
            backgroundColor: theme.palette.warning.light,
            color: theme.palette.warning.dark,
            "& a": {
                color: theme.palette.warning.dark
            }
        },
        error: {
            backgroundColor: (0,_mui_material__WEBPACK_IMPORTED_MODULE_5__/* .lighten */ .$n)(theme.palette.error.light, 0.9),
            color: theme.palette.error.dark,
            "& a": {
                color: theme.palette.error.dark
            }
        },
        dark: {
            backgroundColor: "#2f2e41",
            color: theme.palette.common.white,
            "& a": {
                color: theme.colors.logo.shrimp
            }
        }
    };
}, {
    classNamePrefix: "Banner"
});
var Banner = function(param) {
    var className = param.className, extClasses = param.classes, children = param.children, inProp = param.in, _size = param.size, size = _size === void 0 ? "small" : _size, _variant = param.variant, variant = _variant === void 0 ? "default" : _variant;
    var classes = useStyles({
        classes: extClasses
    });
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        in: inProp,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.root, className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.content, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, classes.big, size === "big"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, classes.small, size === "small"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, classes.dark, variant === "dark"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, classes.success, variant === "success"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, classes.info, variant === "info"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, classes.warning, variant === "warning"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, classes.error, variant === "error"), _obj)),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                children: children
            })
        })
    });
};


/***/ }),

/***/ 28505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ oidc_GoogleButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/oidc/GoogleButton/googleButton.module.scss
var googleButton_module = __webpack_require__(12591);
var googleButton_module_default = /*#__PURE__*/__webpack_require__.n(googleButton_module);
;// CONCATENATED MODULE: ./src/components/oidc/GoogleButton/img/icon.svg
var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgIcon(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 48 48",
    className: "icon_svg__abcRioButtonSvg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fill: "#EA4335",
    d: "M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#4285F4",
    d: "M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#FBBC05",
    d: "M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    fill: "#34A853",
    d: "M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h48v48H0z"
  })));
}
/* harmony default export */ var icon = (SvgIcon);
;// CONCATENATED MODULE: ./src/components/oidc/GoogleButton/index.tsx







var GoogleButton = function(param) {
    var _label = param.label, label = _label === void 0 ? "Log in with Google" : _label, disabled = param.disabled, dark = param.dark, className = param.className, onClick = param.onClick, small = param.small;
    var handleClick = function(e) {
        if (disabled) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (onClick) onClick(e);
    };
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        "aria-label": label,
        onClick: handleClick,
        className: (0,clsx_m/* default */.Z)((googleButton_module_default()).root, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (googleButton_module_default()).dark, dark), (0,_define_property/* default */.Z)(_obj, (googleButton_module_default()).disabled, disabled), (0,_define_property/* default */.Z)(_obj, (googleButton_module_default()).small, small), _obj), className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: (0,clsx_m/* default */.Z)((googleButton_module_default()).googleIcon, "oidc-google-button-icon"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon, {
                    className: (googleButton_module_default()).googleIcon__svg
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (0,clsx_m/* default */.Z)((googleButton_module_default()).btnText, "oidc-google-button-label"),
                children: label
            })
        ]
    });
};
/* harmony default export */ var oidc_GoogleButton = (GoogleButton);


/***/ }),

/***/ 83416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useGoogleLogin; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _consts_storageKeys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14101);
/* harmony import */ var _reclaim_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34160);
/* harmony import */ var _utils_local_storage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91325);
/* harmony import */ var _utils_platform__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94423);
/* harmony import */ var _useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47310);
/* harmony import */ var _useOurRouter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52581);







var useGoogleLogin = function() {
    var router = (0,_useOurRouter__WEBPACK_IMPORTED_MODULE_4__/* .useOurRouter */ .ED)();
    var urlParams = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return new URLSearchParams((0,_utils_platform__WEBPACK_IMPORTED_MODULE_2__/* .browser */ .Xh)().isBrowser ? window.location.search : "");
    }, []);
    return (0,_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_3__/* .useCallbackSafeRef */ .T)(function() {
        var ref;
        (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_5__/* .removeLocalStorage */ .dZ)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_6__/* .LOCAL_STORAGE_AUTH_REAUTH */ .Vt);
        (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_5__/* .removeLocalStorage */ .dZ)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_6__/* .LOCAL_STORAGE_AUTH_ATTEMPTS */ .aJ);
        (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_5__/* .removeLocalStorage */ .dZ)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_6__/* .LOCAL_STORAGE_ACTIVE_QUESTS */ .pZ);
        var storedUser = (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_5__/* .getLocalStorage */ .$o)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_6__/* .LOCAL_STORAGE_AUTH_USER */ .kG);
        var ref1 = (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_5__/* .getLocalStorage */ .$o)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_6__/* .LOCAL_STORAGE_AUTH_REF */ .ZB);
        var utm = (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_5__/* .getLocalStorage */ .$o)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_6__/* .LOCAL_STORAGE_AUTH_UTM */ .$K);
        var slackTeamId = urlParams.get("slackTeamId");
        var slackUserId = urlParams.get("slackUserId");
        var invite = urlParams.get("invite");
        // the check for "://" prevents arbitrary redirection (Open Redirect)
        var oauthRedirect = (ref = router.query.state) === null || ref === void 0 ? void 0 : ref.redirect;
        var redirect = "".concat(!!oauthRedirect && !oauthRedirect.includes("://") ? oauthRedirect : (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_5__/* .getSessionStorage */ .G)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_6__/* .LOCAL_STORAGE_AUTH_REDIRECT */ .I7, "/")).concat(!!invite ? "?invite=1" : "");
        (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_5__/* .removeSessionStorage */ .VV)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_6__/* .LOCAL_STORAGE_AUTH_REDIRECT */ .I7);
        var state = {
            flow: "default",
            redirect: redirect,
            slackTeamId: slackTeamId,
            slackUserId: slackUserId,
            ref: ref1,
            utm: utm
        };
        _reclaim_api__WEBPACK_IMPORTED_MODULE_1__/* .reclaim.users.authRedirect */ .Tz.users.authRedirect("google", storedUser === null || storedUser === void 0 ? void 0 : storedUser.email, state);
    });
};


/***/ }),

/***/ 87586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ LoginLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/Alert/Alert.js + 5 modules
var Alert = __webpack_require__(46901);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 1 modules
var TextField = __webpack_require__(50135);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 1 modules
var Button = __webpack_require__(11057);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./src/utils/scss.utils.ts
var scss_utils = __webpack_require__(91740);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(34557);
// EXTERNAL MODULE: ./src/components/oidc/GoogleButton/index.tsx + 1 modules
var GoogleButton = __webpack_require__(28505);
// EXTERNAL MODULE: ./src/consts/storageKeys.ts
var storageKeys = __webpack_require__(14101);
// EXTERNAL MODULE: ./src/context/UserContext.tsx
var UserContext = __webpack_require__(59484);
// EXTERNAL MODULE: ./src/hooks/useCallbackSafeRef.ts
var useCallbackSafeRef = __webpack_require__(47310);
// EXTERNAL MODULE: ./src/hooks/useCaptureError.ts
var useCaptureError = __webpack_require__(59546);
// EXTERNAL MODULE: ./src/hooks/useGoogleLogin.ts
var useGoogleLogin = __webpack_require__(83416);
// EXTERNAL MODULE: ./src/hooks/useOurRouter.ts
var useOurRouter = __webpack_require__(52581);
;// CONCATENATED MODULE: ./src/img/logomark512maskable.svg
var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgLogomark512Maskable(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fill: "#5267EA",
    d: "M0 0h512v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M339.074 245.632c40.671 0 73.641-32.971 73.641-73.642s-32.97-73.641-73.641-73.641c-40.671 0-73.641 32.97-73.641 73.641 0 40.671 32.97 73.642 73.641 73.642z",
    fill: "#171D26"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M243.353 98H96v147.353h147.353V98z",
    fill: "#EE9AB2"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M339.076 276.794l38.427 68.052 38.498 68.052H262.15l38.498-68.052 38.428-68.052z",
    fill: "#FFC550"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M169.641 413.945c40.671 0 73.642-32.971 73.642-73.642s-32.971-73.641-73.642-73.641S96 299.632 96 340.303c0 40.671 32.97 73.642 73.641 73.642z",
    fill: "#FAFAEE"
  })));
}
/* harmony default export */ var logomark512maskable = (SvgLogomark512Maskable);
// EXTERNAL MODULE: ./src/reclaim-api/index.ts + 13 modules
var reclaim_api = __webpack_require__(34160);
// EXTERNAL MODULE: ./src/utils/local-storage.ts
var local_storage = __webpack_require__(91325);
// EXTERNAL MODULE: ./src/utils/platform.ts
var platform = __webpack_require__(94423);
// EXTERNAL MODULE: ./src/utils/router.ts
var utils_router = __webpack_require__(63429);
// EXTERNAL MODULE: ./src/layouts/LandingLayout.tsx + 4 modules
var LandingLayout = __webpack_require__(23096);
// EXTERNAL MODULE: ./src/layouts/pages/LoginLayout.module.scss
var LoginLayout_module = __webpack_require__(59248);
var LoginLayout_module_default = /*#__PURE__*/__webpack_require__.n(LoginLayout_module);
;// CONCATENATED MODULE: ./src/layouts/pages/LoginLayout.tsx



























var LoginLayout = function(param) {
    var title = param.title, _googleBtnText = param.googleBtnText, googleBtnText = _googleBtnText === void 0 ? "Continue with Google" : _googleBtnText, displayLoginButton = param.displayLoginButton, officeNotice = param.officeNotice, _displaySSO = param.displaySSO, displaySSO = _displaySSO === void 0 ? true : _displaySSO, _displayPreview = param.displayPreview, displayPreview = _displayPreview === void 0 ? false : _displayPreview, _hideBanner = param.hideBanner, hideBanner = _hideBanner === void 0 ? false : _hideBanner, className = param.className, extClasses = param.classes, children = param.children;
    var ref;
    var theme = (0,useTheme/* default */.Z)();
    var classes = (0,scss_utils/* mergeClassNames */.E)((LoginLayout_module_default()), extClasses || {});
    /********************/ /*   custom hooks   */ /********************/ var medium = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("lg"));
    var router = (0,useOurRouter/* useOurRouter */.ED)();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,UserContext/* useUserContext */.SE)(), 1), ref2 = ref1[0], user = ref2.user, isAuthenticated = ref2.isAuthenticated, status = ref2.status;
    var handleGoogleLogin = (0,useGoogleLogin/* useGoogleLogin */.N)();
    var captureError = (0,useCaptureError/* useCaptureError */.e)().captureError;
    /********************/ /*     useState     */ /********************/ var ref3 = (0,react.useState)(), error = ref3[0], setError = ref3[1];
    var ref4 = (0,react.useState)(), ssoEmail = ref4[0], setSsoEmail = ref4[1];
    var ref5 = (0,react.useState)(false), isSso = ref5[0], setIsSso = ref5[1];
    var ssoInputRef = (0,react.useRef)(null);
    /********************/ /* useMemo & consts */ /********************/ var urlParams = (0,react.useMemo)(function() {
        return new URLSearchParams((0,platform/* browser */.Xh)().isBrowser ? window.location.search : "");
    }, []);
    /********************/ /*    useCallback   */ /********************/ var handleClick = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(provider) {
        if (provider === "google") {
            handleGoogleLogin();
        }
    });
    var handleSSOInputChange = function(e) {
        setSsoEmail(e.target.value);
    };
    var handleSSOLogin = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var urlPath, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!ssoEmail) {
                            setError("No SSO Email provided.");
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            reclaim_api/* reclaim.users.ssoLogin */.Tz.users.ssoLogin(ssoEmail)
                        ];
                    case 2:
                        urlPath = _state.sent();
                        if (urlPath) {
                            reclaim_api/* reclaim.users.authRedirect */.Tz.users.authRedirect(urlPath.replace("/oauth/login/", ""));
                            return [
                                2
                            ];
                        }
                        setError("No associated SSO email found.");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        setError("Error while feching SSO URL.");
                        captureError(new Error("Error while fetching URL", {
                            cause: error
                        }));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSSOLogin() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSSOKeyPress = function(e) {
        if (e.key === "Enter") {
            void handleSSOLogin();
        }
    };
    var handleRemoveError = function() {
        void router.replace("/login", undefined, {
            shallow: true
        });
        setError(undefined);
    };
    /********************/ /*    useEffects    */ /********************/ (0,react.useEffect)(function() {
        var ref;
        if (!((ref = router.query) === null || ref === void 0 ? void 0 : ref.reason)) return;
        var reason = router.query.reason;
        setError("USER_DISABLED" === reason ? "Calendar for this email address is linked to another account. Please sign in using your other Google login." : "User not authorized.");
    }, [
        (ref = router.query) === null || ref === void 0 ? void 0 : ref.reason
    ]);
    // focus when isSso changes to true
    (0,react.useEffect)(function() {
        var ref;
        isSso && ((ref = ssoInputRef.current) === null || ref === void 0 ? void 0 : ref.focus());
    }, [
        isSso
    ]);
    // Redirect if user is already authenticated
    (0,react.useEffect)(function() {
        var ref;
        if (!router.isReady || !isAuthenticated) return;
        (0,local_storage/* removeLocalStorage */.dZ)(storageKeys/* LOCAL_STORAGE_AUTH_REAUTH */.Vt);
        (0,local_storage/* removeLocalStorage */.dZ)(storageKeys/* LOCAL_STORAGE_AUTH_ATTEMPTS */.aJ);
        var slackTeamId = urlParams.get("slackTeamId");
        var slackUserId = urlParams.get("slackUserId");
        // the check for "://" prevents arbitrary redirection (Open Redirect)
        var oauthRedirect = (ref = router.query.state) === null || ref === void 0 ? void 0 : ref.redirect;
        var redirect = !!oauthRedirect && !oauthRedirect.includes("://") ? oauthRedirect : (0,local_storage/* getSessionStorage */.G)(storageKeys/* LOCAL_STORAGE_AUTH_REDIRECT */.I7);
        if (redirect) {
            (0,local_storage/* removeSessionStorage */.VV)(storageKeys/* LOCAL_STORAGE_AUTH_REDIRECT */.I7);
        }
        // connect slack user
        if (slackUserId && slackTeamId) {
            reclaim_api/* reclaim.slack.link */.Tz.slack.link(slackUserId, slackTeamId).catch(function(reason) {
                if (404 === reason.status) {
                    captureError(new Error("Slack user not found, redirecting" + reason));
                    reclaim_api/* reclaim.slack.authRedirect */.Tz.slack.authRedirect(slackTeamId);
                    return;
                } else {
                    captureError(new Error("Failed to link slack user " + reason));
                }
            });
        }
        var pathname = (0,utils_router/* getUserOnboardingPath */.gi)("welcome");
        if (user === null || user === void 0 ? void 0 : user.onboarded) {
            if (redirect) pathname = redirect;
            else if (medium) pathname = "/stats";
            else pathname = "planner";
        }
        void router.push({
            pathname: pathname,
            query: router.query
        });
    }, [
        isAuthenticated,
        medium,
        router,
        captureError,
        urlParams,
        user === null || user === void 0 ? void 0 : user.onboarded
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingLayout/* default */.Z, {
        className: (0,clsx_m/* default */.Z)(classes.root, className),
        title: title,
        loading: [
            "init",
            "loading"
        ].includes(status) || !!isAuthenticated,
        hideNav: true,
        hideBanner: hideBanner,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            container: true,
            className: (0,clsx_m/* default */.Z)(classes.gridContainer, (0,_define_property/* default */.Z)({}, classes.previewBackground, displayPreview)),
            justifyContent: "center",
            alignItems: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: classes.wrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        className: classes.logoBtn,
                        component: Link/* Link */.r,
                        href: !!user ? "/" : "//reclaim.ai",
                        size: "medium",
                        "aria-label": "reclaim.ai",
                        disableTouchRipple: true,
                        disableRipple: true,
                        disableFocusRipple: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logomark512maskable, {
                            className: classes.logoBtn__svg
                        })
                    }),
                    children,
                    !!error && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Alert/* default */.Z, {
                        severity: "error",
                        variant: "filled",
                        className: classes.alert,
                        children: [
                            error,
                            "\xa0 If you believe this is an error, please contact support."
                        ]
                    }),
                    isSso && !!displaySSO && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: classes.sso,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                InputProps: {
                                    className: classes.sso__input
                                },
                                ref: ssoInputRef,
                                type: "text",
                                value: ssoEmail,
                                variant: "outlined",
                                placeholder: "Enter your email",
                                onChange: handleSSOInputChange,
                                onKeyPress: handleSSOKeyPress
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "contained",
                                color: "primary",
                                className: classes.sso__btn,
                                onClick: handleSSOLogin,
                                children: "Log in with SSO"
                            })
                        ]
                    }),
                    !!displayLoginButton && !isSso && /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleButton/* default */.Z, {
                        dark: displayPreview,
                        label: googleBtnText,
                        onClick: function() {
                            handleRemoveError();
                            handleClick("google");
                        },
                        className: classes.googleBtn
                    }),
                    !!displayLoginButton && !isSso && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: router.pathname.startsWith("/login") ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            className: classes.subtext,
                            variant: "body2",
                            children: [
                                "Don't have an account? ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                    href: "/signup",
                                    children: "Sign up"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            className: classes.subtext,
                            variant: "body2",
                            children: [
                                "Have an account? ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                    href: "/login",
                                    children: "Log in"
                                })
                            ]
                        })
                    }),
                    !!displaySSO && (!isSso ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: classes.subtext,
                        variant: "body2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            onClick: function() {
                                handleRemoveError();
                                setIsSso(true);
                            },
                            children: "Log in with SSO"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: classes.subtext,
                        variant: "body2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            onClick: function() {
                                handleRemoveError();
                                setIsSso(false);
                            },
                            children: "Go back"
                        })
                    })),
                    !!officeNotice && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        className: classes.subtext,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            href: "mailto:hello@reclaim.ai?subject=Re:%20Office%20365%20Support%20for%20Reclaim&body=Hi%20Reclaim%20Team!%0D%0A%0D%0AI'm%20an%20Office%20365%20user%20and%20would%20love%20to%20stay%20updated%20when%20Reclaim%20works%20for%20O365%20calendars.%0D%0A%0D%0AThanks!",
                            children: "Join O365 waitlist"
                        })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 12591:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"googleButton_root__nHu1p","googleIcon":"googleButton_googleIcon__DvVzM","googleIcon__svg":"googleButton_googleIcon__svg__NPZ6D","btnText":"googleButton_btnText___X4_Y","small":"googleButton_small__s5UEg","dark":"googleButton_dark__nu_t5","disabled":"googleButton_disabled__yO4b1"};

/***/ }),

/***/ 59248:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"LoginLayout_gridContainer__mvgJo","previewBackground":"LoginLayout_previewBackground__RLtRt","subtext":"LoginLayout_subtext__yLtbY","wrapper":"LoginLayout_wrapper__o7i67","logoBtn":"LoginLayout_logoBtn__WlLr6","logoBtn__svg":"LoginLayout_logoBtn__svg__pHSYI","googleBtn":"LoginLayout_googleBtn__eklUu","sso":"LoginLayout_sso__PXh1p","sso__input":"LoginLayout_sso__input__nKU2U","sso__btn":"LoginLayout_sso__btn__Op2b6","alert":"LoginLayout_alert__1qpps"};

/***/ })

}]);